<template>
  <div class="newretail">
    <div class="newretailList" v-if="newretail.length > 0">
      <div class="listTitle">
        <h1>{{ newRetailTitle }}</h1>
      </div>
      <!-- <img
          class="newr-img l"
          src="https://img.chery.cn/pc-newretail-first.jpg"
          alt=""
        /> -->
      <div v-if="newRetailAd && newRetailAd.adPicture" @click="toAdlink">
        <div
          class="commodityFirst"
          :style="{
            'background-image': `url(${newRetailAd ? newRetailAd.adPicture : ''})`,
            height: newretail.length > 4 ? '645px' : '315px'
          }"
        ></div>
      </div>

      <div
        class="newr-box-l"
        :style="{
          width: newRetailAd && newRetailAd.adPicture ? '1100px' : '100%'
        }"
      >
        <Newretail
          class="newr-card"
          v-for="(item, i) in newretail.slice(0, newRetailAd && newRetailAd.adPicture ? 8 : 10)"
          :key="i"
          :info="item"
          :style="{
            'margin-left': newRetailAd && newRetailAd.adPicture ? '15px' : parseInt(i / 5) === i / 5 ? '0' : '15px'
          }"
        ></Newretail>
      </div>
      <!-- <img
          class="newr-img l"
          src="https://img.chery.cn/pc-newretail-fifth.jpg"
          alt=""
        /> -->
    </div>
    <dir class="clear"></dir>
  </div>
</template>
<script>
import Newretail from '@/components/business/mall/newretail'
export default {
  name: '',
  data() {
    return {
      newretail: [],
      newRetailTitle: '新零售车型',
      newRetailAd: {}
    }
  },
  props: {
    xlsList: {
      type: Object,
      default: () => {}
    }
  },
  created() {
    const retail = this.xlsList
    if (retail) {
      this.newRetailTitle = retail.title + '车型'
      this.newretail = retail.itemList
      this.newRetailAd = retail
    }
  },
  watch: {
    newretail(to, from) {
      this.newretail = to
    }
  },
  components: {
    Newretail
  },
  methods: {
    toAdlink() {
      if (this.newRetailAd.adLink) {
        window.location.href = this.newRetailAd.adLink
      }
    }
  }
}
</script>
<style lang="scss">
.listTitle {
  width: 100%;
  height: 70px;
  font-size: 22px;
  font-family: 'NotoSansHans-Bold';
  font-weight: bold;
  // margin-bottom: 20px;
  padding-top: 12px;
  // background-color: lightblue;
  display: flex;
  justify-content: space-between;
  align-items: center;
  > img {
    width: 128px;
    height: 27px;
  }
  h1 {
    height: 42px;
    font-size: 30px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #000000;
    line-height: 42px;
    padding-left: 24px;
    position: relative;
  }
  h1:after {
    content: '';
    width: 4px;
    height: 24px;
    background: #c6001f;
    position: absolute;
    left: 0;
    top: 10px;
  }
}
.listTitle > span:first-child {
  font-size: 32px;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  /* background-color: lightcoral; */
  padding: 0px;
}
.listTitle > span:last-child {
  display: flex;
  align-items: center;
  cursor: pointer;
}
.commodityFirst {
  width: 260px;
  min-height: 315px;
  overflow: hidden;
  float: left;
  background: rgba(255, 255, 255, 1);
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  /* background-color: lightcoral; */
  // box-shadow: 0px 4px 10px 0px rgba(27, 50, 71, .22);
  img {
    width: 100%;
  }
}
.newretailList {
  width: 1360px;
  min-width: 1200px;
  margin: 0px auto;
  .newr-box {
    width: 840px;
    min-height: 315px;
  }
  .newr-img {
    width: 260px;
    height: 315px;
  }
  // .newr-card:nth-child(2),.newr-card:nth-child(7),.newr-card:nth-child(13) {
  //   margin-left: 0px;
  // }
  .newr-box-l {
    width: 100%;
    height: 100%;
    float: left;
    .newr-card {
      cursor: pointer;
      text-decoration: none;
      width: 260px;
      height: 315px;
      position: relative;
      float: left;
      margin-left: 15px;
      margin-bottom: 14px;
      transition: all 0.4s linear;
      background: rgba(255, 255, 255, 1);
    }
  }
}
</style>
